module.exports = __webpack_public_path__ + "media/images/icon/0-de464adffef2a89cc60fc512842f5b93.svg";